import { z } from 'zod'

import {
  IndicationStatusValues,
  IndicationTypeValues,
} from '@/models/backoffice/indications'

export const indicationFormValidationSchema = z.object({
  commission: z
    .string()
    .min(1, 'Digite uma comissão')
    .refine((val) => Number(val.replace('%', '')) <= 100, {
      message: 'A comissão deve ser no máximo 100',
    }),
  indication_type: z.enum(['1', '2'], {
    message: 'Selecione um tipo',
  }),
  indication_entity: z.object({
    id: z.string().min(1, 'Selecione uma entidade'),
    description: z.string().optional(),
  }),
  commission_reason: z
    .string()
    .max(300, 'Limite máximo de 300 caracteres atingido')
    .optional(),

  indication_id: z.string().optional(),
})

export type IndicationFormValues = z.infer<
  typeof indicationFormValidationSchema
>

export const indicationFiltersFormValidationSchema = z.object({
  indications_search: z.string(),
  indications_type: z.enum(['', ...IndicationTypeValues]),
  indications_status: z.enum(['', ...IndicationStatusValues]),
})

export type IndicationFiltersFormValues = z.infer<
  typeof indicationFiltersFormValidationSchema
>
